import Vue from 'vue'
import Router from 'vue-router'

function generateComponentFunction(path) {
  return resolve => require([`@/components${path}`], resolve)
}

const Login = generateComponentFunction('/login/login');
const Activation = generateComponentFunction('/activation/activation');
const Register = generateComponentFunction('/register/register');
const ForgetPassword = generateComponentFunction('/forgetPassword/forgetPassword');
const QualityFollowUp = generateComponentFunction('/report/qualityFollowUp');
const qualityKPI = generateComponentFunction('/report/qualityKPI');
const qualityKPIGeneral = generateComponentFunction('/report/qualityKPIGeneral');
const cptSupplierEvaluation = generateComponentFunction('/report/cptSupplierEvaluation');
const satisfactionRate = generateComponentFunction('/report/satisfactionRate');
const Profile = generateComponentFunction('/profile/profile');
const Parameter = generateComponentFunction('/parameter/parameter');
const monthlyShipmentQTY = generateComponentFunction('/monthlyShipmentQTY/monthlyShipmentQTY');


const Supplier = generateComponentFunction('/supplier/supplier');
const qplManagement = generateComponentFunction('/qplManagement/qplManagement');
const ptmManagement = generateComponentFunction('/ptmManagement/ptmManagement');

const ClaimCategory = generateComponentFunction('/claimCetegory/claimCetegory');
const Feedback = generateComponentFunction('/feedback/feedback');
const Claim = generateComponentFunction('/claim/feedback');
const Questionnaire = generateComponentFunction('/questionnaire/questionnaire');
const Answer = generateComponentFunction('/questionnaire/answer');


Vue.use(Router)

const root = Vue.component('root', {
  template: '<router-view></router-view>'
});

export default new Router({
  routes: [{
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      hidden: true,
      unJump: true
    }
  }, {
    path: '/activation',
    name: 'Activation',
    component: Activation,
    meta: {
      hidden: true,
      unJump: true
    }
  }, {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      hidden: true,
      unJump: true
    }
  }, {
    path: '/answer',
    name: ' Satisfaction Survey ',
    component: Answer,
    meta: {
      hidden: true,
      unJump: true
    }
  }, {
    path: '/forgetPassword',
    name: 'ForgetPassword',
    component: ForgetPassword,
    meta: {
      hidden: true,
      unJump: true
    }
  }, {
    path: '/',
    component: root,
    redirect: {
      path: '/feedback/fabric?type=1'
    },
    meta: {
      requiresAuth: true
    },
    children: [{
      path: '/report',
      component: root,
      name: 'report',
      iconClass: 'bar-chart',
      meta: {
        role: [1, 2, 3, 4, 6, 8, 9, 12, 13, 14, 21, 22, 23, 24]
      },
      children: [{
        path: '/qualityFollowUp',
        component: QualityFollowUp,
        name: 'quality_follow_up',
        meta: {
          parentRouter: 'Report',
          unJump: true,
          role: [1, 2, 3, 4, 8, 12, 13, 14, 21, 23]
        }
      }, {
        path: '/qualityKPI',
        component: qualityKPI,
        name: 'quality_kpi',
        meta: {
          parentRouter: 'Report',
          unJump: true,
          role: [1, 2, 3, 4, 8, 12, 13, 14, 21, 23]
        }
      }, {
        path: '/cptSupplierEvaluation',
        component: cptSupplierEvaluation,
        name: 'cpt_supplier_evaluation',
        meta: {
          parentRouter: 'Report',
          unJump: true,
          role: [1, 2, 3, 4, 6, 8, 9, 12, 13, 14, 21, 22, 23, 24]
        }
      }, {
        //   path: '/qualityKPIGeneral',
        //   component: qualityKPIGeneral,
        //   name: 'quality_kpi_general',
        //   meta: {
        //     parentRouter: 'Report',
        //     unJump: true,
        //     role: [1, 2, 3, 4, 12, 13, 14]
        //   }
        // }, {
        path: '/satisfactionRate',
        component: satisfactionRate,
        name: 'satisfaction_rate',
        meta: {
          parentRouter: 'Report',
          unJump: true,
          role: [1, 2, 3, 4, 8, 12, 13, 14, 21, 23]
        }
      }]
    }, {
      path: '/feedback',
      component: root,
      name: 'feedback',
      iconClass: 'comment',
      meta: {
        role: [1, 2, 3, 4, 5, 6, 7, 8, 9, 12, 13, 14, 21, 22, 23, 24]
      },
      children: [{
        path: 'fabric',
        query: {
          type: 1,
        },
        component: Feedback,
        name: 'cpt_feedback',
        meta: {
          parentRouter: 'Feedback',
          unJump: true,
          role: [1, 2, 3, 5, 6, 12, 13]
        }
      }, {
        path: 'yarn',
        query: {
          type: 2
        },
        component: Feedback,
        name: 'yarn_feedback',
        meta: {
          parentRouter: 'Feedback',
          unJump: true,
          role: [1, 3, 4, 6, 7, 13, 14]
        }
      }, {
        path: 'ccs',
        query: {
          type: 3
        },
        component: Feedback,
        name: 'ccs_feedback',
        meta: {
          parentRouter: 'Feedback',
          unJump: true,
          role: [1, 2, 5, 8, 9, 12]
        }
      }, {
        path: 'package',
        query: {
          type: 4
        },
        component: Feedback,
        name: 'package_feedback',
        meta: {
          parentRouter: 'Feedback',
          unJump: true,
          role: [1, 2, 5, 12, 21, 22]
        }
      }, {
        path: '"productId',
        query: {
          type: 5
        },
        component: Feedback,
        name: 'productId_feedback',
        meta: {
          parentRouter: 'Feedback',
          unJump: true,
          role: [1, 2, 5, 12, 23, 24]
        }
      }]
    }, {
      path: '/supplier',
      component: root,
      name: 'supplier_p',
      iconClass: 'th-large',
      meta: {
        role: [1, 2, 3, 4, 8, 12, 13, 14, 21, 23]
      },
      children: [{
        path: 'fg',
        query: {
          type: 1
        },
        component: Supplier,
        name: 'fg_supplier',
        meta: {
          unJump: true,
          role: [1, 2, 12]
        }
      }, {
        path: 'cpt',
        query: {
          type: 2
        },
        component: Supplier,
        name: 'cpt_supplier',
        meta: {
          unJump: true,
          role: [1, 3, 13]
        }
      }, {
        path: 'yarn',
        query: {
          type: 3
        },
        component: Supplier,
        name: 'yarn_supplier',
        meta: {
          unJump: true,
          role: [1, 4, 14]
        }
      }, {
        path: 'ccs',
        query: {
          type: 4
        },
        component: Supplier,
        name: 'ccs_supplier',
        meta: {
          unJump: true,
          role: [1, 8]
        }
      }, {
        path: 'package',
        query: {
          type: 5
        },
        component: Supplier,
        name: 'package_supplier',
        meta: {
          unJump: true,
          role: [1, 21]
        }
      }, {
        path: 'productId',
        query: {
          type: 6
        },
        component: Supplier,
        name: 'productId_supplier',
        meta: {
          unJump: true,
          role: [1, 23]
        }
      }]
    }, {
      path: '/category',
      component: root,
      name: 'category',
      iconClass: 'paste',
      meta: {
        role: [1]
      },
      children: [{
        path: 'fabric',
        query: {
          type: 1
        },
        component: ClaimCategory,
        name: 'cpt_category',
        meta: {
          parentRouter: 'Category',
          unJump: true,
          role: [1]
        }
      }, {
        path: 'yarn',
        query: {
          type: 2
        },
        component: ClaimCategory,
        name: 'yarn_category',
        meta: {
          parentRouter: 'Category',
          unJump: true,
          role: [1]
        }
      }, {
        path: 'ccs',
        query: {
          type: 3
        },
        component: ClaimCategory,
        name: 'ccs_category',
        meta: {
          parentRouter: 'Category',
          unJump: true,
          role: [1]
        }
      }, {
        path: 'package',
        query: {
          type: 4
        },
        component: ClaimCategory,
        name: 'package_category',
        meta: {
          parentRouter: 'Category',
          unJump: true,
          role: [1]
        }
      }, {
        path: 'productId',
        query: {
          type: 5
        },
        component: ClaimCategory,
        name: 'productId_category',
        meta: {
          parentRouter: 'Category',
          unJump: true,
          role: [1]
        }
      }]
    }, {
      path: '/monthlyShipmentQTY',
      component: monthlyShipmentQTY,
      name: 'monthly_shipment',
      iconClass: 'hashtag',
      meta: {
        unJump: true,
        role: [1, 3, 4, 6, 7, 8, 9, 13, 14]
      }
    }, {
      path: '/qplManagement',
      component: qplManagement,
      name: 'qpl_management',
      iconClass: 'user-plus',
      meta: {
        unJump: true,
        role: [1, 12, 13, 14]
      }
    }, {
      path: '/ptmManagement',
      component: ptmManagement,
      name: 'ptm_management',
      iconClass: 'user-plus',
      meta: {
        unJump: true,
        role: [1]
      }
    }, {
      path: '/parameter',
      component: Parameter,
      name: 'parameter',
      iconClass: 'sitemap',
      meta: {
        unJump: true,
        role: [1]
      }
    }, {
      //   path: '/questionnaire',
      //   component: Questionnaire,
      //   name: 'Satisfaction Survey',
      //   iconClass: 'file-text-o',
      //   meta: {
      //     unJump: true,
      //     role: [1]
      //   }
      // }, {
      path: '/profile',
      component: Profile,
      name: 'profile',
      iconClass: 'user',
      meta: {
        unJump: true,
        role: [1, 2, 3, 4, 5, 6, 7, 8, 9, 12, 13, 14]
      }
    }, {
      path: '/claim',
      component: root,
      name: 'claim',
      iconClass: 'certificate',
      meta: {
        role: [5, 6]
      },
      children: [{
        path: 'fabric',
        query: {
          type: 1
        },
        component: Claim,
        name: 'cpt_claim',
        meta: {
          parentRouter: 'Claim',
          unJump: true,
          role: [5]
        }
      }, {
        path: 'yarn',
        query: {
          type: 2
        },
        component: Claim,
        name: 'yarn_claim',
        meta: {
          parentRouter: 'Claim',
          unJump: true,
          role: [6]
        }
      }, {
        path: 'css',
        query: {
          type: 3
        },
        component: Claim,
        name: 'css_claim',
        meta: {
          parentRouter: 'Claim',
          unJump: true,
          role: [5]
        }
      }, {
        path: 'package',
        query: {
          type: 4
        },
        component: Claim,
        name: 'package_claim',
        meta: {
          parentRouter: 'Claim',
          unJump: true,
          role: [5]
        }
      }, {
        path: 'productId',
        query: {
          type: 5
        },
        component: Claim,
        name: 'productId_claim',
        meta: {
          parentRouter: 'Claim',
          unJump: true,
          role: [5]
        }
      }]
    }]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js